// src/components/button/ToggleSelectedOnly.tsx

import { FilterListTwoTone } from '@mui/icons-material'
import { IconButton, Tooltip, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'

type Props = {
  onChange: (selectedOnly: boolean) => void
  value?: boolean
}

export const ToggleSelectedOnly = ({ onChange, value = false }: Props) => {
  const theme = useTheme()
  const { main: color } = theme.palette.secondary

  const [selectedOnly, setSelectedOnly] = useState(value)
  const toggle = () => setSelectedOnly(prev => !prev)

  const icon =
    selectedOnly === true ? (
      <FilterListTwoTone sx={{ color }} />
    ) : (
      <FilterListTwoTone />
    )

  const tooltip =
    selectedOnly === true
      ? 'Nicht ausgewählte Sensoren ausblenden'
      : 'Nicht ausgewählte Sensoren einblenden'

  useEffect(() => onChange(selectedOnly), [onChange, selectedOnly])

  return (
    <Tooltip title={tooltip}>
      <IconButton onClick={toggle} sx={{ m: 0 }}>
        {icon}
      </IconButton>
    </Tooltip>
  )
}
